

module.exports =  {
          header:{
            nav1:"首页",
            nav2:"解决方案",
            nav3:"核心技术",
            nav4:"下载中心",
            nav5:"关于我们",
            nav6:"加入我们",
            nav8:"VR直播／点播",
            nav9:"VR秀场直播",
            nav10:"2D高清视频",
            nav11:"产品",
            nav12:"威尔云平台",
            nav13:"LightVR",
            nav14:"LightEncoder",
            nav15:"播放端SDK",
            nav16:"软件下载",
            nav17:"SDK下载",
            navBtn:"了解更多",
            nav7:"创始团队"

          },
          text1:"联系我们",
          text2:'您好，我是威尔直播的客服小V，请留下您的联系方式',
          text3:'我们将会在1个工作日内与您联系。<span style="color:#ff5959;vertical-align:middle">*</span>为必填项',
          text4:"公司名称",
          text5:'姓名',
          text6:"电话",
          text7:"电子邮箱",
          error:"非常抱歉，系统正在维护",
          error503:"操作过于频繁，请您稍后再试",
          error409:"您已提交，请勿重复操作",
          send:"发送",
          text8:"发送成功",
          text9:"威尔直播小V将尽快主动与您取得联系",
          text10:"好的",

        
  footer:{
    text1:"总机：",
    text2:'86 755 8695 6559',
    text3:'商务合作：',
    text4:"86 755 8696 0615",
    text5:'邮箱：',
    text6:"business@vrviu.com",
    text7:'地址：深圳市南山区科技园琼宇路特发信息科技大厦1-2楼',
    text8:'<a href="http://www.vrviu.com/sdk/document/威尔云使用条款与法律声明.pdf" style="text-decoration: underline;color:#454545;line-height:5em" download="威尔云使用条款与法律声明.pdf">使用条款 & 法律声明</a><br>深圳威尔视觉传媒有限公司<br>© 2016-2018 vrviu.com 版权所有 粤ICP备17011655号'
  },
        index: {
          header: {
            navBtn: "登录",
            navBtn2: "注册",
            nav13: "管理后台",
            nav14: "退出登录",
            nav15: "产品",
          },
          text1: "联系我们",
          text2: '您好，我是威尔直播的客服小V，请留下您的联系方式',
          text3: '我们将会在1个工作日内与您联系。<span style="color:#ff5959;vertical-align:middle">*</span>为必填项',
          text4: "公司名称",
          text5: '姓名',
          text6: "电话",
          text7: "电子邮箱",
          error: "非常抱歉，系统正在维护",
          error503: "操作过于频繁，请您稍后再试",
          error409: "您已提交，请勿重复操作",
          send: "发送",
          text8: "发送成功",
          text9: "我们已经收到您的申请，会尽快与您与的联系。",
          text10: "好的"
        },
        about: {
      name:"关于我们",
      text1:"让每个人都能享受VR直播的乐趣",
      text2:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下,",
      text3:"享受到身临其境的VR体验。",
      text4:"创始团队",
      text5:'我们总部位于深圳南山科技园，并在美国硅谷设有研究院 VRVIU，核心技术团队来自SIE、腾讯、Harmonic等世界顶级公司，拥有领先业界的音视频编解码专利算法技术、3D游戏和数字场景重构技术。',
      text6:'创始人 & CEO',
      text7:"联合创始人",
      text8:"CPO",
      text9:"人力资源副总裁",
      text10:"加入我们"
    },
        product: {
          name:"LightVR",
          banner_text: " 8K VR 直播/点播",
          banner_text2: " 一站式解决方案",
          banner_text1: '－ LightVR －',
          banner_botton: "免费下载 ",
          introduction_title: "LightVR 8K 播放器",
          introduction_text11: "在线播放或.vr1文件离线播放均可享受威尔云8K VR体验",
          introduction_text12: "iMAX级巨幕影院体验，畅享4K高清视频",
          introduction_text13: "多个播放列表间方便切换，适应多种演示和业务场景",
          introduction_title2: "LightVR 小程序",
          introduction_title3: "主要功能",
          introduction_text2: "使用微信即可体验VR视频",
          introduction_text21: "在手机上体验 4K 品质",
          introduction_text22: "支持点播视频或者视频列表 ",
          introduction_text23: "全屏和VR模式之间切换",
          introduction_text24: "将视频分享给朋友们",
          introduction_title4: "多终端适配",
          platform_pic1: "Cardboard",
          platform_pic2: "Pico",
          platform_pic3: "小米VR",
          platform_pic4: "HTC Vive",
          platform_pic5: "Oculus",
          platform_pic6: "微信小程序",
          introduction_title5: '需要更多平台适配或播放器定制？',
          text45: "联系我们"
        },
        product2: {
          name:"LightEncoder",
          banner_text: "8K VR 直播/点播",
          banner_text1: '一站式解决方案',
          banner_botton: '立即下载',
          introduction_title: "LightEncoder 主要功能",
          introduction_text1: "本地使用laptop或者PC即可转码",
          introduction_text2: "避免大体积视频的上传和下载",
          introduction_text3: "自定义转码时长，快速体验转码结果",
          introduction_text44: "支持转码队列，节约操作成本",
          introduction_title2: "转码设备推荐配置",
          introduction_text4: "处理器：Intel Core i5 4核@3.0GHz或更高配置 ",
          introduction_text5: "内存：16G 或者更高 RAM",
          introduction_text6: "硬盘：100G 以上可用空间",
          introduction_text7: "操作系统： Windows 7 64-bit 或 Windows 10 64-bit",
          text25: "获取LightEncoder",
          text26: "LightEncoder 尚处于 Beta 测试阶段",
          text28: "采用授权码激活可用时长",
          text29: "请联系我们获取授权码",
          text27: "联系我们"
        },
        product3: {
          name:"威尔云平台",
          banner_text: "8K VR 直播/点播",
          banner_text1: "一站式解决方案",
          banner_botton: "立即体验",
          introduction_title: "威尔云平台主要功能",
          text20: "全面的VR视频转码支持",
          text21: "支持 180°/360° , 2D/3D VR视频",
          text22: "支持 3K ～ 8K 的视频源输入",
          text23: "支持 H264,H265,VP9 等主流编码格式",
          text24: "支持最大 10GB 的单视频上传",
          text30: "多种转码规格可供选择",
          text31: "视焦点 FE 6K/8K 提供极致的高清体验",
          text32: "视焦点 FE 3K/4K 适用于网络流畅播放",
          text33: "普通 2.5K/3K/4K  适用于Web播放",
          text40: "便捷的视频管理服务",
          text41: "视频编辑、发布、在线播放",
          text42: "根据业务需要定制网络播单",
          text43: "FE 6K/8K 大文件可提供下载",
          introduction_title2: "为什么选择威尔云",
          platform_pic1: "威尔云专利视焦点算法",
          platform_pic11: "视角切换零延迟，带宽节约70%",
          platform_pic12: "带来绝佳的8K VR 视频享受",
          platform_pic2: "全面的VR视频转码支持",
          platform_pic21: "支持180°/360° , 2D/3D 的VR格式",
          platform_pic22: "支持H264,H265,VP9 等主流编码格式",
          platform_pic3: "多种转码规格可供选择",
          platform_pic31: "视焦点编码提供极致高清体验",
          platform_pic32: "普通编码适用于常规播放器",
          platform_pic4: "便捷的一站式解决方案",
          platform_pic41: "视频编辑、发布、在线播放",
          platform_pic42: "根据业务需要定制网络播单",

          text25: "免费试用威尔云",
          text26: "注册威尔云账号，免费体验威尔云在智能编码、稳定",
          text29: "传输和流畅播放等方面的强大技术优势。",
          text27: "立即体验",
          text28: '查看<a target="_blank" href="https://master.vrviu.com/static/document/Master%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.pdf" style="text-decoration: underline;  display: inline-block;vertical-align: middle;color:#fff;margin-bottom:4px;margin-left:5px;">帮助文档</a>，更多问题请<a   style="margin-left:5px;text-decoration: underline; margin-bottom:4px; display: inline-block;vertical-align: middle;color:#fff;cursor:pointer" id="contract">联系我们</a>'

        },
        features: {
          name:"播放端SDK",
          banner_text:"8K VR 直播/点播的",
          banner_text1:"一站式解决方案",
          banner_button:"免费下载",
          text1: "播放端SDK",
          text2: "7x24小时稳定直播",
          text3: "高性能，低消耗",
          text4: "秒开，流畅切换",
          text5: "多开发环境",
          text6: "VR视频播放端SDK",
          text7: "WebVR视频播放器SDK",
          text8: "普通视频“窄带高清”播放端SDK",
          text9: "支持多种美颜滤镜",
          text10: '2017.09.30 发布推流端SDK V0.6版',
          text11: '下载',
          text12: 'VR视频Web播放SDK',
          text13: "高度定制化的播放器UI",
          text14: "支持360度全景、180度3D等多种格式的视频文件",
          text15: "支持手势拖拽和陀螺仪旋转等播放操作<br>支持微信、QQ、Chrome、Safari等平台播放",
          text16: "2018.03.08 发布 WebVR Player 版本V1.0",
          text17: "常见问答",
          text18: "是否可以不接入播放端SDK使用VRVIU的算法？",
          text19: "我们的FE算法基于H.264/H.265在编码上做了极为有效的优化，相应的，在播放端需要做相应的解码计算。基于上面的原理，播放端需要使用威尔云提供的SDK。",
          text20: "接入播放端SDK包后App大小会增加多少？",
          text21: '我们的核心SDK约为1M，但具体大小与您选择的我们的产品，以及您当前的App采用的技术有关。',
          text22: "联系我们",
          text23: 'Android',
          text111: "SDK下载",
          text112: "文档下载",
          text113: "Demo体验",
         table1: {
                     title: "VR视频播放端SDK",
                     label1: "支持最大分辨率",
                     label11: "音视频编码",
                     label12: "支持传输协议",
                     label13: "视频格式",
                     label14: "投影方式",
                     label15: "播放模式",
                     label16: "解码方式",
                     label17: "支持平台",
                     label18: "支持芯片",
                     label19: "支持设备",
                     label10: "支持FE专利算法",
                     text1: "VR 视频 8192*8192@60fps",
                     text102: "普通视频 3840*3840@60fps",
                     text103: "",
                     text2: "H.264 | H.265 | AAC",
                     text3: "RTMP | HTTP MP4 | HTTP FLV | HLS",
                     text4: "180° 3D | 360° 2D | 360° 3D",
                     text5: "等距圆柱 | 鱼眼",
                     text6: "直播 | 点播",
                     text7: "硬解 | 软解",
                     text8: "ARMV7 | ARM64 | X86",
                     text9: "高通 820+ | 全志VR9 | Samgsung8890+",
                     text10: "GearVR | Oculus Go | XIAOMI | Pico | HTC VIVE | DPVR | 3Glasses | Cardboard",
                     text11: "带宽节省高达75%，8K视频播放只需20Mbps"
                   },
                   table2: {
                     title: "WebVR视频播放器SDK",
                     label1: "支持最大分辨率",
                     label2: "音视频编码",
                     label3: "视频格式",
                     label4: "播放模式",
                     label5: "播放操作",
                     label6: "播放支持",
                     label7: "UI",
                     label8: "FE专利算法",
                     text1: "3840*1920@30fps",
                     text2: "H.264 | H.265 | AAC",
                     text3: "180° 3D | 360° 2D | 360° 3D",
                     text4: "直播 | 点播",
                     text5: "支持手势拖拽和陀螺仪旋转等播放操作",
                     text6: "支持主流的Web浏览器播放",
                     text7: "可定制化",
                     text8: "支持"
                   },
                   table3: {
                     title: "普通视频“窄带高清”播放端SDK",
                     label1: "支持最大分辨率",
                     label2: "音视频编码",
                     label3: "播放模式",
                     label4: "解码方式",
                     label5: "支持传输协议",
                     label6: "秒开",
                     label7: "支持系统",
                     label8: "支持FE专利算法",
                     text1: "3840*2160",
                     text2: "H.264 | H.265 | AAC",
                     text3: "直播 | 点播 ",
                     text4: "硬解 | 软解",
                     text5: "RTMP | HTTP MP4 | HTTP FLV | HLS ",
                     text6: "支持首屏秒开",
                     text7: "Android | iOS | HTML5",
                     text8: "带宽节省高达40%, 720p@H.265仅需600Kbps"
                   }
        },
        devolop: {
          name:"SDK下载",
          title1: "SDK下载",
          title2: "威尔VR视频播放端SDK",
          title3: "(VRVIU BitPlayer SDK)",
          title4: "Unity",
          version1: "版本号：V2.8",
          date1: "发布日期：2018.11.08",
          button1: "开发文档",
          button2: "SDK下载",
          title55: "HTML5",
          version2: "版本号：V1.0",
          date2: "发布日期：2018.05.17",
          title5: "普通视频“窄带高清”播放SDK",
          title6: "（VRVIU AltPlayer SDK）",
          title7: "iOS",
          version3: "版本号：V1.3",
          date3: "发布日期：2018.04.19",
          title8: "Android",
          Version4: "版本号：V1.3",
          date4: "发布日期：2018.04.28",
          title9: "HTML5",
          version5: "版本号：V1.0",
          date5: "发布日期：2018.05.07",
          title10: "VR秀场推流软件",
          title11: "（VBS）",
          title12: "PC侧安装",
          version6: "版本号：V1.0",
          date6: "发布日期：2018.05.11",
          title13: "手机端观看效果",
          version7: "版本号：Android V1.0",
          date7: "发布日期：2018.05.04",
          button3: "立即体验",
          button4: "软件下载",
          button5: "即将上线",
          title14: "LightVR App",
          title15: "（下载体验威尔专利算法的优质体验）",
          title16: "Cardboard for Android",
          Version8: "版本号：V1.2",
          date8: "发布日期：2018.05.02",
          title17: "Cardboard for iOS",
          version9: "",
          date9: ""
        },
        solution: {
        name:"VR直播／点播",
        name1:"VR秀场直播",
        name2:"2D高清视频",
        banner_text:"告别卡顿渣画质<br>重新定义VR直播</div>",
        banner_botton:"下载Demo",
        title1:"180° 3D / 360°全景：视角切换零延迟",
        text1:'180° 3D 适合小型近距离的表演和运动，360° 全景VR适合大场面、全方位的游戏、赛事和演唱会。威尔云通过对视频内容的多视角智能编解码，可在普通家庭网络带宽下，让高清流畅与沉浸感成为可能。',
        text2:'',
        text3:"威尔直播云服务",
        text4:'VR演出',
        text5:'秀场VR直播，支持实时美颜和滤镜，<br>与主播近距离互动。',
        text6:'VR体育',
        text7:'体育VR直播，以全新视角零距离观<br>看体育明星的表演',
        text8:'游戏VR',
        text9:'演出VR直播，独享演唱会的VIP坐席',
        text10:'360°全景：视角切换延迟零延迟',
        text11:"360° VR直播适合大场面、全方位的游戏、赛事、",
        text12:"旅行及演唱会，带来身临其境的体验",
        text13:'游戏VR直播',
        text14:'游戏VR直播，让观众可以身临虚拟世界，近距离观摩高手之间的较量，感受惊心动魄的一刻。',
        text15:'新闻VR直播',
        text16:'新闻VR直播，带你去现场，不错过任何精彩',
        text17:'旅行VR直播',
        text18:'旅行VR直播，与主播一同攀登珠峰，深潜海底，环游世界。',
        text19:'威尔云 6 大特性',
        text20:'低带宽',
        text21:'带宽节省高达70%，让高清与流畅并存',
        text22:'低延迟',
        text23:'优于业界金字塔、八面体等算法，切换延迟低至毫秒级',
        text24:'低功耗',
        text25:'智能视频编解码，支持中低端手机上的4K播放',
        text26:'标准协议',
        text27:'使用标准RTMP流，支持DASH、HLS等多种传输协议',
        text28:"服务稳定可靠",
        text29:'高并发，7x24稳定直播',
        text30:'多终端适配',
        text31:"支持Android/iOS/H5/Gear VR等多平台播放",
        text32:'核心技术',
        text33:'多平台适配',
        text34:'免费试用',
        text35:'常见问答',
         text36:'威尔播放器SDK相比其他播放器SDK有哪些优势？',
        text37:"威尔播放器SDK分为免费版和付费版，免费版支持标准的VR高清视频的流畅播放，付费版拥有在现有带宽下，体验真正的4K VR视频，高清、低切换延时等算法功能。您可以先下载体验免费版SDK，再与我们联系了解付费版详情。",
        text38:"现在已经在用公有云或私有云的直播服务，能接入威尔云服务吗？",
        text39:"威尔云支持现有多家CDN，公有云和私有云的部署。并且客户可以根据自己的需要，对指定内容开启威尔云服务。高效利用现有带宽，体验真正的4K VR视频。",
        text40:'对接威尔云服务是时间成本有多少？',
        text41:'在已有支持协议的基础上，对接体验只需要2分钟。',
        text42:"接入威尔云后的延时大概是多少秒？",
        text43:"威尔云在系统内部和视角切换上的延迟小于等于1秒，并且在切换时，带宽完全平滑，没有现陡现象。直播传输延迟由视频流的编码参数以及所在网络环境决定。",
        text44:'更多问题？',
        text45:'联系我们',
        text46:"",
      },
        solution2: {
        name:"VR秀场直播",
        name1:"VR直播／点播",
        name2:"2D高清视频",
        banner_text:"上行带宽减少70%<br>迎接全民VR直播时代",
        banner_botton:"下载Demo",
        title1:"VR秀场直播：零距离与主播实时互动",
        text1:'180° 3D 的VR秀场直播，主播可以在家庭带宽条件下实现高清推流，用户可以以低于4Mbps的带宽体验4K秀场直播内容。支持实时互动、美颜和滤镜，打破主播与观众“一屏之隔”的距离。',
        text2:'',
        text3:"威尔直播云服务",
        text4:'VR演出',
        text5:'秀场VR直播，支持实时美颜和滤镜，<br>与主播近距离互动。',
        text6:'VR体育',
        text7:'体育VR直播，以全新视角零距离观<br>看体育明星的表演',
        text8:'游戏VR',
        text9:'演出VR直播，独享演唱会的VIP坐席',
        text10:'360°全景：视角切换延迟零延迟',
        text11:"360° VR直播适合大场面、全方位的游戏、赛事、",
        text12:"旅行及演唱会，带来身临其境的体验",
        text13:'游戏VR直播',
        text14:'游戏VR直播，让观众可以身临虚拟世界，近距离观摩高手之间的较量，感受惊心动魄的一刻。',
        text15:'新闻VR直播',
        text16:'新闻VR直播，带你去现场，不错过任何精彩',
        text17:'旅行VR直播',
        text18:'旅行VR直播，与主播一同攀登珠峰，深潜海底，环游世界。',
        text19:'威尔云 6 大特性',
        text20:'低带宽',
        text21:'带宽节省高达70%，让高清与流畅并存',
        text22:'低延迟',
        text23:'优于业界金字塔、八面体等算法，切换延迟低至毫秒级',
        text24:'低功耗',
        text25:'智能视频编解码，支持中低端手机上的4K播放',
        text26:'标准协议',
        text27:'使用标准RTMP流，支持DASH、HLS等多种传输协议',
        text28:"服务稳定可靠",
        text29:'高并发，7x24稳定直播',
        text30:'多终端适配',
        text31:"支持Android/iOS/H5/Gear VR等多平台播放",
        text32:'核心技术',
        text33:'多平台适配',
        text34:'免费试用',
        text35:'常见问答',
      text36:'VR秀场直播中，对于主播的上行带宽有什么要求和限制吗？',
        text37:"通过使用威尔推流和播放SDK，主播的上行带宽只需要2Mbps - 4Mbps即可。",
        text38:"主播端使用什么推流软件，是否可以使用我们私有的直播软件进行VR秀场的直播推流？",
        text39:"威尔云在开源直播推流软件OBS的基础上，进行了改造优化，推出了专为VR且拥有威尔算法的推流软件VBS，供主播使用。若想要在私有直播推流软件上加入威尔算法，需要联系我们进行沟通技术细节。",
        text40:'是否支持Web/H5网页内的播放？',
        text41:'威尔针对H5的性能，开发了易于分享和传播的威尔WebVR播放器，高清流畅，可以在“开发者”页中下载SDK体验。',
        text42:"有推荐使用的180度3D相机吗？",
        text43:'目前我们支持 <a style="color:#0078e7" href="http://www.z-cam.com/180-vr-camera-k1-pro/" target="_blank">ZCAM K1 Pro</a>。另外，Google也官方推荐了多款VR 180相机，譬如<a href="http://www.yitechnology.com/180-vr-camera" target="_blank" style="color:#0078e7">YI Horizon VR180</a>。',
        text44:'更多问题？',
        text45:'联系我们',
        text46:"",
      },
        home: {
          index:{
                 banner_title:'8K VR视频播放',
                 banner_text:'真正沉浸体验',
                 notice:'2018.12.10 威尔云本地转码工具LightEncoder V1.1发布',
                 title1:'威尔云：视频的高清低带宽一站式解决方案',
                 vrviu:'认识威尔云',
                 item_title1:'挑战高清极限',
                 item_title2:'节省70%带宽',
                 item_title3:'适用多种场景',
                 item_title4:'服务稳定可靠',
                 item_text1:'支持 4K／6K／8K 视频流<br>尽享极致沉浸体验',
                 item_text2:'主流手机流畅播放4K+<br>内容，流量节省70%',
                 item_text3:'180º3D，360全景<br>可以根据不同场景选择',
                 item_text4:'高并发，低延迟<br>7x24稳定直播，多平台',
                 pic_text1:'VR秀场',
                 pic_text2:'游戏VR',
                 pic_text3:'VR体育',
                 pic_text4:'VR演出',
                 pic_text5:'VR新闻',
                 title2:"多种应用场景",
                 title3:"眼见为实",
                 download_title2:'视频来源：<a href="https://www.amaze.us" class="dance_link" target="_blank">AMAZE VR | Dance with Magga</a>',
                 download_title:'模拟VR眼镜中看到的4Mbps码率的视频，建议全屏观看比较视频细节。',
                 try_download:'下载体验LightVR 8K播放器',
                 try_download_text:'马上体验威尔云服务提供的秀场/电竞/体育等VR视频样片。',
                 try_download_btn:'下载',
                 try_free:'免费试用威尔云',
                 try_free_text:'体验威尔云在智能编码、稳定传输',
                 try_free_text2:"和流畅播放等强大技术优势。",
                 try_free_btn:'了解更多',
                 friends:"合作伙伴"



               },
               download:'了解更多',
               text4:"秀场直播",
               text5:"游戏直播",
               text6:"小视频"
        },
        technology: {
      name:"核心技术",
      text1:'威尔云 · 创建VR高速公路',
      text2:'专利FE (Foveated Encoding) 算法',
      text3:'自研高清视频编解码算法，使用基于视焦点的多层自适应视角方案。相比传统的VR自适应视角方案，能够做到更高的压缩效率，更快的视角切换，更少的带宽浪费以及更加平稳顺滑的网络状态。',
      text4:'VR视频，',
      text5:"带宽可节约高达70%",
      text6:'上行带宽节省高达70%，解决4K直播上传障碍，',
      text7:"让主播在家就可痛快高清直播",
      text8:"普通视频，",
      text9:"720p仅需600Kbps",
      text10:'下行带宽节省高达70%，解决用户端',
      text11:"流畅看高清的难题，在家即可享受VR直播的乐趣",
      text12:"超低视角切换延迟,",
      text13:"稳定高效传输",
      text14:'威尔云拥有强大稳定的传输能力，',
      text15:'满足高并发、低延迟的极端要求',
      text18:'智能编解码',
      text19:'机器学习大数据',
      text20:'威尔云可以智能判断视频内容来适配最优算法，',
      text21:'更多数据，更大编解码优化空间。',
      text23:"专利音频编解码，动态还原3D音效<br>（Coming soon）",
      text24:"威尔云可将3D空间音效，以极低码率同时又高保真的独特编码，并动态还原在VR世界中",
      text25:"下载体验Demo App",
      text26:"马上体验威尔云服务提供的秀场、电竞和体育等VR视频样片。",
      text27:"下载Demo",
      text28:'应用场景',
      text30:"每个像素都被等同对待<br>和大脑的视觉观看主观特性无关",
      text31:"根据视焦点来动态分配像素<br>更符合人的主观观感质量",
      text32:'了解算法原理详情：<br><a href="https://www.vrviu.com/sdk/document/Improving Network Bandwidth Usage with Foveated encoding(1).pdf" target="_blank" style="color:#0084ff">Improving Network Bandwidth Usage with Foveated encoding.pdf</a>'


    },
        solution3: {
        name:"2D高清视频",
        name1:"VR直播／点播",
        name2:"VR秀场直播",
        banner_text:"更低带宽消耗<br>高清流畅体验",
        banner_botton:"下载Demo",
        title1:"2D高清视频：720P仅需600Kbps",
        text1:'针对高清2D视频内容，例如秀场直播、第一人称射击游戏直播等，威尔云通过对视频内容的智能编解码，大幅度降低带宽消耗，带来前所未有的高清流畅播放体验。',
        text2:'',
        text3:"威尔直播云服务",
        text4:'秀场直播',
        text5:'秀场VR直播，支持实时美颜和滤镜，<br>与主播近距离互动。',
        text6:'小视频点播',
        text7:'体育VR直播，以全新视角零距离观<br>看体育明星的表演',
        text8:'游戏直播',
        text9:'演出VR直播，独享演唱会的VIP坐席',
        text10:'360°全景：视角切换延迟零延迟',
        text11:"360° VR直播适合大场面、全方位的游戏、赛事、",
        text12:"旅行及演唱会，带来身临其境的体验",
        text13:'游戏VR直播',
        text14:'游戏VR直播，让观众可以身临虚拟世界，近距离观摩高手之间的较量，感受惊心动魄的一刻。',
        text15:'新闻VR直播',
        text16:'新闻VR直播，带你去现场，不错过任何精彩',
        text17:'旅行VR直播',
        text18:'旅行VR直播，与主播一同攀登珠峰，深潜海底，环游世界。',
        text19:'威尔云 6 大特性',
        text20:'低带宽',
        text21:'带宽节省高达70%，让高清与流畅并存',
        text22:'标准协议',
        text23:'优于业界金字塔、八面体等算法，切换延迟低至毫秒级',
        text24:'低成本',
        text25:'智能视频编解码，支持中低端手机上的4K播放',
        text26:'秒开',
        text27:'使用标准RTMP流，支持DASH、HLS等多种传输协议',
        text28:"低功耗",
        text29:'高并发，7x24稳定直播',
        text30:'多终端适配',
        text31:"支持Android/iOS/H5/Gear VR等多平台播放",
        text32:'核心技术',
        text33:'多平台适配',
        text34:'免费试用',
        text35:'常见问答',
     text36:'威尔云的高清2D视频解决方案适合怎样的应用场景？',
        text37:"我们的2D解决方案推荐应用在有视焦点的视频内容上。我们的算法可以动态识别图像内容，发挥最优的效果。例如，秀场直播，第一人称射击游戏直播等内容。",
        text38:"是否支持推流软件端的压缩传输？",
        text39:"威尔云目前只支持在服务器端的压缩传输。",
        text40:'威尔云转码服务是如何工作的？',
        text41:'针对转码场景，可以有多码率，多种分辨率；针对不转码场景，有单一码率，单一分辨率。同时我们支持算法开关，可以根据内容需要选择开启威尔云服务或关闭，最大程度节省带宽并利用服务器资源。',
        text42:"是否支持H.265视频编码？",
        text43:"威尔云同时支持H.264和H.265视频压缩编码。",
        text44:'更多问题？',
        text45:'联系我们',
        text46:"",
        text47:"是否支持Web/H5网页内的播放？",
        text48:"威尔云支持H5的高清播放，便于分享和传播。"
      },
        download: {
          title: "LightVR App",
          text: "下载即可体验威尔云技术处理后，多种VR场景下(包括秀场、游戏、体育、）适用的视频。"
        },
        join: {
      name:"加入我们",
      text1:"让每个人都能享受VR直播的乐趣",
      text2:"我们致力于“VR高速公路”的建设，让用户在现有的带宽和技术条件下,",
      text3:"享受到身临其境的VR体验。",
      text4:"创始团队",
      text5:'我们总部位于深圳南山科技园，并在美国硅谷设有研究院 VRVIU，核心技术团队来自SIE、腾讯、Harmonic等世界顶级公司，拥有领先业界的音视频编解码专利算法技术、3D游戏和数字场景重构技术。',
      text6:"效率",
      text7:"扁平化管理<br>弹性工作时间",
      text8:"成长",
      text9:"导师培养机制<br>赴美交流机会",
      text10:"欢乐",
      text11:"灵活办公，定期团建<br>带薪休假10-15天",
      text12:'与威尔直播一起创造',
      text13:"在威尔直播，每个人都是创造者。扁平化的管理让所有人的想法都能发声，共同实现属于我们的VR梦想。",
      text14:"学习成长",
      text15:'VRVIU关注每个员工的成长，全公司采用导师培养机制，更有机会赴美交流，与硅谷技术大神一起工作学习。',
      text16:"创始团队"
    },
        software: {
          name:"软件下载",
          download: "立即下载",
          banner_text: "软件下载",
          introduction_title: "LightVR App",
          introduction_title2: "（享受威尔云带来的高清VR体验）",
          product_title1: "Cardboard<span class='platform_info2'>（Android）</span>",
          product_vison1: "版本号：2.5",
          product_date1: "更新日期：2018-10-19",
          product_title2: "LightVR for Pico",
          product_vison2: "版本号：2.5",
          product_date2: "更新日期：2018-11-05",
          product_title3: "LightVR 小程序",
          product_vison3: "版本号：2.1",
          product_date3: "更新日期：2018-11-26",
          product_title4: "LightVR for Vive",
          product_vison4: "敬请期待",
          product_date4: "",
          product_title5: "LightVR for Oculus",
          product_vison5: "敬请期待",
          product_date5: "",
          product_title6: "LightVR for MiVR",
          product_vison6: "敬请期待",
          product_date6: "",
          introduction_title3: "LightEncoder",
          introduction_title4: "（8K VR视频本地转码工具)",
          product_title7: "LightEncoder<span class='platform_info2'>（Windows）</span>",
          product_vison7: "版本号：1.1",
          product_date7: "更新日期：2018-12-10",
          product_title8: "LightEncoder<span class='platform_info2'>（Linux）</span>",
          product_vison8: "敬请期待",
          product_date8: "",
          introduction_title5: "VBS直播套件 ",
          introduction_title6: "（180°2D/3D VR 直播推流解决方案）",
          product_title9: "推流端软件<span class='platform_info2'>（Windows）</span>",
          product_vison9: "版本号：1.0",
          product_date9: "更新日期：2018-05-11",
          product_title10: "播放端软件<span class='platform_info2'>（Android）</span>",
          product_vison10: "版本号：1.0",
          product_date10: "更新日期：2018-05-11",
          introduction_text: "LightEncoder 尚处于 Beta 测试阶段，采用授权码激活可用时长，<br>请联系我们获取授权码"

        }


}




//////////////////
// WEBPACK FOOTER
// ./static/js/ch.js
// module id = 109
// module chunks = 0